export default __webpack_public_path__ + "static/media/Face-search.13047ce7.png";